import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    changePlan: 'Change plan',
    withMultiWallet: {
      description: 'For more wallets, upgrade your plan.',
      includedWallets: {
        plural:
          'You currently have {walletLimit} wallets included in your plan.',
        singular:
          'You currently have {walletLimit} wallet included in your plan.',
      },
      title: 'Need more wallets?',
    },
    withoutMultiWallet: {
      items: [
        'Put money aside',
        'Separate your spending items',
        'Make transfers and direct debits directly from your wallets, without going through your main account',
      ],
      title: 'Organise your cash flow with wallets',
    },
  },
  fr: {
    changePlan: 'Changer d’offre',
    withMultiWallet: {
      description:
        'Pour bénéficier de plus de sous‑comptes, passez sur une offre supérieure.',
      includedWallets: {
        plural:
          'Vous bénéficiez actuellement de {walletLimit} sous‑comptes inclus dans votre offre.',
        singular:
          'Vous bénéficiez actuellement de {walletLimit} sous‑compte inclus dans votre offre.',
      },
      title: 'Besoin de plus de sous‑comptes\xA0?',
    },
    withoutMultiWallet: {
      items: [
        'Mettez de l’argent de côté',
        'Séparez vos principaux postes de dépenses',
        'Effectuez vos virements et prélèvements directement depuis vos sous‑comptes, sans passer par votre compte principal',
      ],
      title: 'Organisez votre trésorerie avec les sous‑comptes',
    },
  },
} as const);

export default locales;
